import { render, staticRenderFns } from "./_Afkir.vue?vue&type=template&id=68222f96&"
import script from "./_Afkir.vue?vue&type=script&lang=js&"
export * from "./_Afkir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports